<template>
    <div>
    <v-app-bar
      app
      flat
      color="white"
      elevation="0"
      class="noprint app-topbar"
    >

        <v-app-bar-nav-icon class="hovp d-flex d-md-none" color="#FB8C00" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

        <div class="align-center text-uppercase d-flex">
            <a href="/" rel="noopener noreferrer">
                <v-img
                alt="Logo"
                class="shrink mr-2"
                contain
                src="/images/myschlogo.png"
                transition="scale-transition"
                width="70"
                />
            </a>
            <div class="topbar-module-label d-none d-sm-flex align-center">
                <span class="module-dot"></span>
                <span>{{ moduleName }}</span>
            </div>
        </div>
        <v-spacer></v-spacer>

        <guest-menu-card-2 class="d-none d-sm-flex" v-if="isLoggedIn === false && isTokenAccess === false"/>
        <v-chip color="#FFF3E0" v-if="isLoggedIn === true"><span class="d-none d-sm-block">Token Balance: &nbsp;</span><span><v-icon size="20px" color="#FB8C00">mdi-shield-key</v-icon></span>&nbsp;  {{ tokens }} &nbsp;<a v-if="tokens < 3" class="nav-link2" href="#"  @click="buyTokenModal = !buyTokenModal"> Topup</a> </v-chip>&nbsp;
        <router-link v-if="isLoggedIn === true" class="nav-link" :to="{name: 'TokenHistory'}"><v-icon size="20px">mdi-history</v-icon> </router-link>
    </v-app-bar>
        <v-navigation-drawer
        v-model="drawer"
        app
        dark
        :permanent="$vuetify.breakpoint.mdAndUp"
        :temporary="$vuetify.breakpoint.smAndDown"
        width="290"
        class="noprint app-sidebar"
        >
      <div class="sidebar-module-badge ma-4 pa-3 rounded-lg">
        <div class="text-overline font-weight-bold text-center">{{ moduleName }}</div>
      </div>
      <v-divider class="sidebar-divider mb-2"></v-divider>
      <side-menu-card :menu="menu" v-if="isLoggedIn === true"/>
      <guest-menu-card v-if="isLoggedIn === false && isTokenAccess === false"/>
      <token-user-menu-card v-if="isLoggedIn === false && isTokenAccess === true"/>

      <sidebar-footer/>
        </v-navigation-drawer>
        <buy-token-modal v-if="buyTokenModal"/>
    </div>
</template>

<script>
import { mapState } from "vuex";
import BuyTokenModal from './BuyTokenModal.vue';
import GuestMenuCard from './GuestMenuCard.vue';
import GuestMenuCard2 from './GuestMenuCard2.vue';
import SideMenuCard from './SideMenuCard.vue';
import SidebarFooter from './SidebarFooter.vue';
import TokenUserMenuCard from './TokenUserMenuCard.vue';

export default {
  components: { BuyTokenModal, SideMenuCard, GuestMenuCard, TokenUserMenuCard, GuestMenuCard2, SidebarFooter },
    name: 'AppTopBar',
    data: () => ({
        drawer: false,
        group: null,
        buyTokenModal: false
    }),
    props:[
        'menu',
        'color',
        'moduleName'
    ],
    created() {
        if (this.isLoggedIn && this.school) {
            this.$store.dispatch('fetchTokens', this.school.school_id);
        }
    },
    computed: {
        ...mapState({
            isLoggedIn: (state) => state.isLoggedIn,
            emailVerified: (state) => state.emailVerified,
            isTokenAccess: (state) => state.isTokenAccess,
        }),
        tokens() {
            return this.$store.state.tokensLeft; // Reactively updates
        },
        school (){
            if (this.isLoggedIn == true) {
                return JSON.parse(localStorage.getItem('school'))
            }
            return JSON.parse(localStorage.getItem('school'))
        }
    },
    watch: {
        group () {
            this.drawer = false
        }
    },
    methods:{
    }
};
</script>

<style scoped>
.app-topbar{
    border-bottom: 1px solid #ECEFF7;
}
.nav-link2{
    text-decoration: none;
    color: #1E3C72;
    background: linear-gradient(135deg, #FFD54F 0%, #FFA726 100%);
    font-weight: 700;
    padding: 3px 12px;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.nav-link{
    color: #FB8C00 !important;
    opacity: 0.85;
    transition: opacity 0.2s ease;
}
.nav-link:hover{
    opacity: 1;
}
.module-dot{
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #FB8C00;
    margin-right: 10px;
    flex-shrink: 0;
}
.topbar-module-label{
    color: #1E3C72;
    font-weight: 700;
    font-size: 0.72rem;
    letter-spacing: 2px;
    text-transform: uppercase;
    margin-left: 16px;
}
.app-sidebar{
    background: linear-gradient(180deg, #1E3C72 0%, #14233F 100%) !important;
    border-right: 1px solid rgba(255, 255, 255, 0.06);
}
.sidebar-module-badge{
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    text-align: center;
    position: relative;
}
.sidebar-module-badge .text-overline{
    letter-spacing: 2px;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.92);
}
.sidebar-module-badge::after{
    content: '';
    display: block;
    width: 28px;
    height: 3px;
    margin: 8px auto 0;
    border-radius: 2px;
    background: #FB8C00;
}
.sidebar-divider{
    border-color: rgba(255, 255, 255, 0.1) !important;
}
</style>

